import { GRAVITY, PITBOSS as SIM_PITBOSS, SKILL_COOLDOWN, SKILL_IDS, TIME_STOP, VAMPIRE_CHARGE, type Kind, type SkillId } from '@orb/sim';

/** Gameplay numbers live in @orb/sim; this file adds what only the client needs: names, colours, copy. */
export {
  BOARD_COOP, BOARD_PARTNER, BOARD_SOLO, ENEMY_SCALE, GRAVITY, KINDS, KIND_STATS, L, MAX_LEVEL, RUNNER, SUMMON_WEIGHTS,
  TIME_STOP, VAMPIRE_CHARGE, WILD, type Kind, type KindStats, type SkillId,
} from '@orb/sim';

/** sRGB hex per relic kind. */
export const KIND_COLOR: Record<Kind, number> = { r: 0xff4a2a, b: 0x4aa8ff, y: 0xffc840, g: 0x5ad673, a: 0xb27cff, w: 0xe6eeff, v: 0xef3268, t: 0xe6b878, o: 0xff6ab4, k: 0xff7a22, s: 0x46e8f0 };
/** The orb shader's recipe per sphere (fx/orbMaterial.ts): 9 and 10 are the totems' hearts. */
export const KIND_ELEMENT: Record<Kind, number> = { r: 0, b: 1, y: 2, g: 3, a: 4, w: 5, v: 6, t: 7, o: 8, k: 11, s: 12 };
export const KIND_NAME: Record<Kind, string> = { r: 'Рубін', b: 'Сапфір', y: 'Цитрин', g: 'Смарагд', a: 'Аметист', w: 'Призма', v: 'Кривавий гранат', t: 'Сонячний годинник', o: 'Онікс', k: 'Обсидіан', s: 'Око бурі' };
export const LEVEL_NAME = ['I', 'II', 'III', 'IV', 'V'];

/** Contextual player-facing explanation, kept in sync with the rank's actual effect. */
export function relicDetail(kind: Kind, level: number): string | null {
  const g = Math.max(0, Math.min(4, level - 1));
  if (kind === 'v') return `Одна ціль. Власне вбивство: +${VAMPIRE_CHARGE[g].toFixed(2).replace('.', ',')} заряду печатки.`;
  if (kind === 't') return `Зупинка часу на ${TIME_STOP.duration[g].toFixed(2).replace('.', ',')} с. ${TIME_STOP.targets[g] === 1 ? 'Найближчий ворог.' : `До ${TIME_STOP.targets[g]} ворогів поблизу.`}`;
  if (kind === 'o') return `Гравітаційний вир ${GRAVITY.duration[g].toFixed(1).replace('.', ',')} с: стягує ворогів у купу й сповільнює.`;
  return null;
}

const SKILL_COPY: Record<SkillId, { name: string; detail: string; color: number }> = {
  meteor: { name: 'Вогняний град', detail: 'Шість метеорів. Земля палає ще 4.5 с.', color: 0xff8246 },
  barrier: { name: 'Крижана стіна', detail: 'Клік по дорозі: стіна з крижаних брил перекриває дорогу. Вороги розбивають її ударами, бігуни перестрибують.', color: 0x67b9d0 },
  haste: { name: 'Перенапруга', detail: 'Сфери атакують удвічі швидше протягом 6 с.', color: 0xffd66d },
  frost: { name: 'Крижана хвиля', detail: 'Клік по дорозі: хвиля холоду заморожує всіх в області, і босів теж, на 2.6 с.', color: 0x9ea6ff },
};
export const SKILLS: { id: SkillId; name: string; detail: string; cooldown: number; color: number }[] =
  SKILL_IDS.map((id) => ({ id, cooldown: SKILL_COOLDOWN[id], ...SKILL_COPY[id] }));

export const PITBOSS = { ...SIM_PITBOSS, color: 0xaf73ff };
